module.exports = __webpack_public_path__ + "static/media/zimbabue.c6405603.jpg";